import { render } from "./LayerDataSheet.vue?vue&type=template&id=5a4c1a1f&scoped=true"
import script from "./LayerDataSheet.vue?vue&type=script&lang=js"
export * from "./LayerDataSheet.vue?vue&type=script&lang=js"

import "./LayerDataSheet.vue?vue&type=style&index=0&id=5a4c1a1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4c1a1f"]])

export default __exports__